import React from 'react'
import DatePicker from 'react-datepicker';
import Select from "react-select";
import { Label } from 'reactstrap';
import { CalenderIcon } from '../../Icon';
import { components } from 'react-select';
import { CircularAvatar, DropDown, ToggleSwitch } from '../../commons';
import moment from 'moment';
import { JOBS_PRIORITY } from '../../../constant/jobs';
import { LoginResponseType } from '../../../redux/auth/authTypes';

type AppProps = {
    jobsData: any;
    jobsError: any;
    loginData?:LoginResponseType;
    recurringData:any;
    userFetching: boolean;
    setoffset: any;
    setJobTypeOffset: (e: any) => void;
    setJobTypeText: (e: any) => void;
    fetching: boolean;
    checkJobTypeBottom: () => void;
    setText: any;
    type?: string;
    checkBottom: () => void;
    finalClientList: any;
    finalJobTypeList: any;
    clientFetching: boolean;
    checkClientBottom: () => void;
    singlejobsData?:any;
    setClientOffset: (e: any) => void;
    setClientText: (e: any) => void;
    singleJobsType: any;
    handleChange: (data: any, name: string) => void;
    startDateError:string
}

const BasicDetails = ({ jobsData,
    finalClientList,
    setJobTypeOffset,
    setJobTypeText,
    fetching,
    checkJobTypeBottom,
    clientFetching,
    recurringData,
    jobsError,
    userFetching,
    setoffset,
    setText,
    type,
    singleJobsType,
    checkClientBottom,
    setClientOffset,
    singlejobsData,
    setClientText,
    checkBottom,
    handleChange,
    finalJobTypeList,
    startDateError,
    loginData
}: AppProps) => {
    const Option = (props: any) => {
        const { data } = props;
        return (
            <components.Option {...props} >
                <div className='d-flex justify-content-sm-start' style={{ gap: '10px' }}>
                    <CircularAvatar name={data?.label.split("%")[0]} image={data?.image && data?.image} />
                    <div style={{ marginTop: "-3px" }}>
                        <span style={{ fontWeight: "500", fontSize: "16px" }}>{data?.label.split("%")[0]}</span>
                        <br></br>
                        <span style={{ color: "#6e7491" }}>{data?.label.split("%")[1]}</span>
                    </div>
                </div>
            </components.Option>
        );
    };

    return (
        <div>
            <div className='row'>

                <div className='col-md-4 form-group mt-3'>
                    <label htmlFor='Select Client' className='mb-2'>Client<span className='color-red'>*</span></label>
                    <Select
                        options={finalClientList}
                        isDisabled={type === "editJobCard"}
                        value={jobsData?.client}
                        onChange={(e: any) => handleChange(e, "client")}
                        isSearchable={true}
                        components={{ Option }}
                        isLoading={clientFetching}
                        onMenuClose={() => { setClientOffset(0) }}
                        onMenuScrollToBottom={checkClientBottom}
                        onInputChange={(e) => {
                            setClientText(e)
                        }}
                    />
                    <div>{!!jobsError?.client && <small className="text-danger">{jobsError?.client}</small>}</div>
                </div>

               {type==="editJobCard" && ( <div className='col-md-4 form-group mt-3'>
                <label htmlFor='Job Status' className='mb-2'>Job Status</label>
                    <ToggleSwitch
                        handleToggleChange={() => handleChange("","jobStatus")}
                        isChecked={jobsData?.jobStatus}
                        disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                    />
                </div>)}
            </div>

            <div className='row'>
                {/*  */}
                <div className='col-md-4 form-group mt-3'>
                    <label >Job Type<span className='color-red'>*</span></label>
                    <div className='mt-1'>
                        <Select
                            className="dropdown"
                            isDisabled={type === "editJobCard" || (singlejobsData?.job_status=="Closed")}
                            name="jobType"
                            placeholder={"Search User"}
                            value={jobsData?.jobType}
                            options={finalJobTypeList}
                            onChange={(e: any) => handleChange(e, "jobType")}
                            isSearchable={true}
                            isLoading={fetching}
                            onMenuClose={() => { setJobTypeOffset(0) }}
                            onMenuScrollToBottom={checkJobTypeBottom}
                            onInputChange={(e) => {
                                setJobTypeText(e)
                            }}
                        />
                    </div>
                    <div>{!!jobsError?.jobType && <small className="text-danger">{jobsError?.jobType}</small>}</div>
                </div>

                <div className='col-md-4 form-group mt-3'>
                    <label >Period Ended<span className='color-red'>*</span></label>
                    <div className="d-flex flex-row position-relative mt-1">

                        <div className="date-picker-wraper mr-0 w-100">
                            <Label className="m-0 p-0 w-100">
                                <DatePicker
                                    disabled={type === "editJobCard" || ( singlejobsData?.job_status=="Closed" && loginData?.user_id!=1)}
                                    dateFormat="dd-MM-yyyy"
                                    selected={
                                        jobsData?.periodEnded
                                            ? new Date(
                                                moment(`${jobsData?.periodEnded}T00:00:00`, "DD-MM-YYYY").format(
                                                    "YYYY-MM-DD[T]HH:mm:ss"
                                                )
                                            )
                                            : null
                                    }
                                    onChange={(e: any) => handleChange((e ? moment(e).format("DD-MM-YYYY") : null), "periodEnded")}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name="NextPeriodEnd"
                                    placeholderText="Choose Date"
                                    className="form-control pointer"
                                />
                                <span
                                    className="calender-icon"
                                    style={{ right: "5px", cursor: "pointer" }}
                                >
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>
                    <div>{!!jobsError?.periodEnded && <small className="text-danger">{jobsError?.periodEnded}</small>}</div>
                </div>

            </div>

            <div className='row'>
                <div className='col-md-4 form-group mt-3'>
                    <label>Job Priority</label>
                    <div className='mt-1'>
                        <DropDown
                            options={JOBS_PRIORITY}
                            value={jobsData?.jobPriority}
                            handleChange={(e: any) => handleChange(e, "jobPriority")}
                            disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                        />
                    </div>
                </div>

                <div className='col-md-4 form-group mt-3'>
                    <label >Target Start Date</label>
                    <div className="d-flex flex-row position-relative mt-1">

                        <div className="date-picker-wraper mr-0 w-100">
                            <Label className="m-0 p-0 w-100">
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={
                                        jobsData?.targetStartDate
                                            ? new Date(
                                                moment(`${jobsData?.targetStartDate}T00:00:00`, "DD-MM-YYYY").format(
                                                    "YYYY-MM-DD[T]HH:mm:ss"
                                                )
                                            )
                                            : null
                                    }
                                    onChange={(e: any) => handleChange((e ? moment(e).format("DD-MM-YYYY") : null), "targetStartDate")}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name="targetStartDate"
                                    placeholderText="Choose Date"
                                    className="form-control pointer"
                                    disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                                />
                                <span
                                    className="calender-icon"
                                    style={{ right: "5px", cursor: "pointer" }}
                                >
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>

                <div>{!!startDateError&& <small className="text-danger">{startDateError}</small>}</div>
                </div>

                <div className='col-md-4 form-group mt-3'>
                    <label >Target End Date</label>
                    <div className="d-flex flex-row position-relative mt-1">

                        <div className="date-picker-wraper mr-0 w-100">
                            <Label className="m-0 p-0 w-100">
                                <DatePicker
                                    dateFormat="dd-MM-yyyy"
                                    selected={
                                        jobsData?.targetEndDate
                                            ? new Date(
                                                moment(`${jobsData?.targetEndDate}T00:00:00`, "DD-MM-YYYY").format(
                                                    "YYYY-MM-DD[T]HH:mm:ss"
                                                )
                                            )
                                            : null
                                    }
                                    onChange={(e: any) => handleChange((e ? moment(e).format("DD-MM-YYYY") : null), "targetEndDate")}
                                    fixedHeight
                                    showMonthDropdown
                                    showYearDropdown
                                    name="NextPeriodEnd"
                                    placeholderText="Choose Date"
                                    className="form-control pointer"
                                    disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                                />
                                <span
                                    className="calender-icon"
                                    style={{ right: "5px", cursor: "pointer" }}
                                >
                                    <CalenderIcon />
                                </span>
                            </Label>
                        </div>
                    </div>

                </div>
            </div>

            <div className='row'>
                <div className="col-md-6">
                    <form>
                        <div className="form-group mt-3">
                            <div>
                                <label
                                    htmlFor="menuName"
                                >
                                    Job Description
                                </label>
                                <textarea
                                    className="form-control"
                                    name="jobDesc"
                                    style={{ height: "115px", resize: "none" }}
                                    onChange={(e: any) => handleChange(e, "jobDesc")}
                                    value={jobsData?.jobDesc}
                                    disabled={singlejobsData?.job_status=="Closed" && loginData?.user_id!=1}
                                />

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default BasicDetails